import React from 'react';
import { Link } from 'react-router-dom';
import projectData from '../data/projectData';
import '../styles/PortfolioPreview.css';

function PortfolioPreview() {
  return (
    <section className="portfolio-preview">
      <div className="container">
        <h2>Our Work</h2>
        <div className="portfolio-grid">
          {projectData.slice(0, 4).map((project) => (
            <Link to={`/portfolio/${project.id}`} key={project.id} className="portfolio-item">
              {/* <img src={project.image} alt={project.title} /> */}
              <h3>{project.title}</h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PortfolioPreview;
